import { Spacing24 } from 'autogen/design-tokens/tokens';
import type { BasketContentViewModel } from 'autogen/swagger/all';
import Flex from 'components/Layout/components/Flex';
import BasketGiftSelect from '../BasketGiftSelect';
import BasketItems from '../BasketItems/BasketItems';
import BasketValidationMessages from '../BasketValidationMessages';
import DonationBanner from 'components/donationBanner/donationBanner';
import SignupNudgingCardWithImage from 'components/clubMatas/onboarding/SignupNudgingCardWithImage';
import SwapCertificateButton from 'components/basket/BasketItem/components/Actions/components/SwapCertificateButton';
import usePointOfSaleRequest from 'hooks/user/usePointOfSaleRequest';

export default function BasketContent({ model: basketContent }: { model: BasketContentViewModel }) {
    const { signupNudging, donation, validationInfo, basketLineGroups } = basketContent.basket;
    const { isPosRequest } = usePointOfSaleRequest();

    return (
        <Flex.Column gap={Spacing24}>
            {/* Validation Errors (otc Errors) */}
            <BasketValidationMessages model={validationInfo} />

            {/* Basket Items */}
            <BasketItems model={basketLineGroups} />

            {/* Signup Club matas nudge (for both club matas and plus) */}
            {signupNudging && <SignupNudgingCardWithImage model={signupNudging} displayLoginOptions />}

            {/* Gift Selection (samples, gwp, optInGifts) */}
            <BasketGiftSelect model={basketContent} />

            {/* Donation Banner (ukraine donation banner) */}
            {donation && <DonationBanner model={donation} />}

            {/* Toggle allowing all basket lines to get a swap certificate */}
            {isPosRequest && (
                <SwapCertificateButton
                    initialSwapCertificateState={basketLineGroups
                        .flatMap((x) => x.basketLines.map((x) => x.giftSwapInfo.hasSwapCertificate))
                        .every((x) => x)}
                />
            )}
        </Flex.Column>
    );
}
